import { Messages } from '../../features/cabinet'
export const MessagesPage = () => {
    return (
        <Messages />
    )
}
